import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { WrapperModal, ModalDescription, ModalCloseBtn } from './styles';

const Snackbar = ({
  isOpen,
  children,
  autoClose,
  autoCloseTime,
  onRequestClose,
}) => {
  useEffect(() => {
    const timer =
      isOpen && autoClose
        ? setTimeout(() => {
            onRequestClose();
          }, autoCloseTime)
        : null;

    return () => clearTimeout(timer);
  }, [isOpen, onRequestClose, autoCloseTime]);

  return (
    <WrapperModal isOpen={isOpen}>
      <ModalDescription>{children}</ModalDescription>
      <ModalCloseBtn
        outline
        size="small"
        type="button"
        onClick={onRequestClose}
      >
        ОК
      </ModalCloseBtn>
    </WrapperModal>
  );
};

Snackbar.propTypes = {
  children: PropTypes.node,
  autoClose: PropTypes.bool,
  autoCloseTime: PropTypes.number,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
};

Snackbar.defaultProps = {
  children: '',
  autoClose: true,
  autoCloseTime: 30000,
  isOpen: false,
};

export default Snackbar;
